export default __webpack_public_path__ + "static/media/Governor.31fc41b8.webp";